var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c(
        "el-form",
        {
          staticClass: "bill-form-content",
          attrs: {
            "label-position": "left",
            "label-width": _vm.isZh ? "85px" : "135px",
            model: _vm.billing
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 5, type: "flex" } },
            [
              _c(
                "el-col",
                { staticStyle: { width: "630px" }, attrs: { span: 8 } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "section",
                      staticStyle: { flex: "1", height: "100%" }
                    },
                    [
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_BillNo") }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "1" },
                                model: {
                                  value: _vm.billing.billingNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billing, "billingNo", $$v)
                                  },
                                  expression: "billing.billingNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_SettleAccountsTo")
                              }
                            },
                            [
                              !_vm.isBySettlementAgent
                                ? _c("el-input", {
                                    attrs: { disabled: true, no: "2" },
                                    model: {
                                      value: _vm.billing.settlement,
                                      callback: function($$v) {
                                        _vm.$set(_vm.billing, "settlement", $$v)
                                      },
                                      expression: "billing.settlement"
                                    }
                                  })
                                : _vm._e(),
                              _vm.isBySettlementAgent
                                ? _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: "",
                                      no: "settlement",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      "default-value":
                                        Number(_vm.billing.accountId) === 0
                                          ? ""
                                          : Number(_vm.billing.accountId),
                                      disabled: _vm.isView,
                                      "method-params": { auto_accountId: true },
                                      cache: false,
                                      "tag-name": _vm.isZh
                                        ? "chineseName"
                                        : "englishName",
                                      "static-options": _vm.accountArray
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.billing.accountId = p.value
                                        _vm.$emit("accountIdChange")
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_SettlementAgent")
                              }
                            },
                            [
                              _vm.isBySettlementAgent
                                ? _c("el-input", {
                                    attrs: {
                                      disabled: true,
                                      no: "settlementAgentId"
                                    },
                                    model: {
                                      value: _vm.billing.settlementAgent,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.billing,
                                          "settlementAgent",
                                          $$v
                                        )
                                      },
                                      expression: "billing.settlementAgent"
                                    }
                                  })
                                : _vm._e(),
                              !_vm.isBySettlementAgent
                                ? _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: "",
                                      no: "3",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      "default-value":
                                        Number(
                                          _vm.billing.settlementAgentId
                                        ) === 0
                                          ? ""
                                          : Number(
                                              _vm.billing.settlementAgentId
                                            ),
                                      disabled: _vm.isView,
                                      "method-params": { auto_accountId: true },
                                      cache: false,
                                      "tag-name": _vm.isZh
                                        ? "chineseName"
                                        : "englishName",
                                      "static-options": _vm.settlementAgentArray
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        return (_vm.billing.settlementAgentId =
                                          p.value)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_InvoiceHeader")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.static_data_Title,
                                  no: "4",
                                  "allow-create":
                                    !_vm.arSettlementUnitOptional ||
                                    !_vm.billing.ar,
                                  filterable: "",
                                  cache: false,
                                  disabled: _vm.isView,
                                  "default-value": _vm.invoiceTitleUuid,
                                  "tag-value": "uuid",
                                  "static-options": _vm.titleArray
                                },
                                on: { parentCallBack: _vm.titleChangeEvent }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Partners.CustomerMailbox")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "customerEmail" },
                                model: {
                                  value: _vm.billing.customerEmail,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billing, "customerEmail", $$v)
                                  },
                                  expression: "billing.customerEmail"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_RegistrationAddress"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: _vm.isView, no: "5" },
                                model: {
                                  value: _vm.billing.buyerAddress,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billing, "buyerAddress", $$v)
                                  },
                                  expression: "billing.buyerAddress"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "inline" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_RegistrationNumber"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "6" },
                                model: {
                                  value: _vm.billing.buyerTaxAccount,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.billing,
                                      "buyerTaxAccount",
                                      $$v
                                    )
                                  },
                                  expression: "billing.buyerTaxAccount"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("CargoMsg.Cargo_Tel") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: _vm.isView, no: "7" },
                                model: {
                                  value: _vm.billing.buyerTelephone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billing, "buyerTelephone", $$v)
                                  },
                                  expression: "billing.buyerTelephone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "inline" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_DepositBank")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.static_data_TitleBank,
                                  no: "8",
                                  "default-value": _vm.titleBankUuid,
                                  disabled: _vm.isView,
                                  cache: false,
                                  "tag-value": "uuid",
                                  "static-options": _vm.titleBankArray
                                },
                                on: { parentCallBack: _vm.getBankCusFromChild }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AccountNumber")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "9" },
                                model: {
                                  value: _vm.billing.buyerBankAccount,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.billing,
                                      "buyerBankAccount",
                                      $$v
                                    )
                                  },
                                  expression: "billing.buyerBankAccount"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_RevenueAndExpenditureType"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  no: "10",
                                  value: _vm.billing.ar
                                    ? _vm.$t("CargoMsg.Cargo_Receivable")
                                    : _vm.$t("CargoMsg.Cargo_Dues")
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "inline" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_OwnerBankOfDeposit"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  cache: false,
                                  disabled: _vm.isView,
                                  no: "11",
                                  "select-type":
                                    _vm.selectTypeNames.static_data_BankAccount,
                                  "default-value":
                                    _vm.billing.bankAccountId === 0
                                      ? ""
                                      : _vm.billing.bankAccountId,
                                  "static-options": _vm.ourBankAccountArray
                                },
                                on: {
                                  parentCallBack: _vm.getOurBankAccountFromChild
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AccountNumber")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "12" },
                                model: {
                                  value: _vm.billing.bankAccount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billing, "bankAccount", $$v)
                                  },
                                  expression: "billing.bankAccount"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_BillDate")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "13",
                                  type: "date",
                                  clearable: false,
                                  editable: false,
                                  disabled: _vm.isView,
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd"
                                },
                                on: { change: _vm.inputDateChange },
                                model: {
                                  value: _vm.billing.inputDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billing, "inputDate", $$v)
                                  },
                                  expression: "billing.inputDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_DueDate") }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "14",
                                  type: "date",
                                  clearable: false,
                                  editable: false,
                                  disabled: _vm.isView,
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.billing.dueDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billing, "dueDate", $$v)
                                  },
                                  expression: "billing.dueDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AgentBillNo")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled:
                                    (_vm.billing.state > 0 && !_vm.isView) ||
                                    _vm.isView,
                                  no: "15"
                                },
                                model: {
                                  value: _vm.billing.counterPartyBillingNo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.billing,
                                      "counterPartyBillingNo",
                                      $$v
                                    )
                                  },
                                  expression: "billing.counterPartyBillingNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.billing.billingType ===
                                  _vm.BILLING_TYPE_INTERNAL.code &&
                                !_vm.billingNoteContainInvoice,
                              expression:
                                "billing.billingType === BILLING_TYPE_INTERNAL.code && !billingNoteContainInvoice"
                            }
                          ]
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Invoice.invoice_invoiceCategory")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.isView,
                                    no: "17",
                                    placeholder: _vm.isView
                                      ? ""
                                      : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                    clearable: ""
                                  },
                                  on: { change: _vm.changeInvoiceMakeType },
                                  model: {
                                    value: _vm.billing.invoiceMakeType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.billing,
                                        "invoiceMakeType",
                                        $$v
                                      )
                                    },
                                    expression: "billing.invoiceMakeType"
                                  }
                                },
                                _vm._l(_vm.invoiceMakeTypes, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.chineseName,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.billing.billingType ===
                                  _vm.BILLING_TYPE_INTERNAL.code &&
                                !_vm.billingNoteContainInvoice,
                              expression:
                                "billing.billingType === BILLING_TYPE_INTERNAL.code && !billingNoteContainInvoice"
                            }
                          ]
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_InvoiceType")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.isView,
                                    no: "16",
                                    placeholder: _vm.isView
                                      ? ""
                                      : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.billing.invoiceType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.billing, "invoiceType", $$v)
                                    },
                                    expression: "billing.invoiceType"
                                  }
                                },
                                _vm._l(_vm.invoiceTypes, function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.chineseName,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.billing.billingType ===
                                  _vm.BILLING_TYPE_INTERNAL.code ||
                                _vm.billing.billingType ===
                                  _vm.BILLING_TYPE_OVERSEA.code,
                              expression:
                                "billing.billingType === BILLING_TYPE_INTERNAL.code || billing.billingType === BILLING_TYPE_OVERSEA.code"
                            }
                          ]
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "Billing.billingJob_settlementType"
                                )
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { disabled: _vm.isView, no: "18" },
                                  model: {
                                    value: _vm.billing.settlementType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.billing,
                                        "settlementType",
                                        $$v
                                      )
                                    },
                                    expression: "billing.settlementType"
                                  }
                                },
                                [
                                  _vm.billing.settlementType === 0
                                    ? _c("el-option", {
                                        key: -1,
                                        attrs: { label: " ", value: 0 }
                                      })
                                    : _vm._e(),
                                  _vm._l(_vm.SETTLEMENT_TYPE_STATES, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: _vm.$store.getters.isZh
                                          ? item.chineseName
                                          : item.englishName,
                                        value: item.code
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.billingFormParams.billingNoteContainInvoiceReques
                        ? _c(
                            "el-col",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_InvoicingType"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        disabled: _vm.isView,
                                        no: "makeInvoiceType"
                                      },
                                      on: { change: _vm.makeInvoiceTypeChange },
                                      model: {
                                        value: _vm.billing.makeInvoiceType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.billing,
                                            "makeInvoiceType",
                                            $$v
                                          )
                                        },
                                        expression: "billing.makeInvoiceType"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_LotteryDraw"
                                          ),
                                          value: 0
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_SchoolMonth"
                                          ),
                                          value: 1
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.billingNoteContainInvoice
                        ? _c(
                            "el-col",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { disabled: _vm.isView },
                                  on: { change: _vm.detailMakeInvoiceChange },
                                  model: {
                                    value: _vm.billing.detailMakeInvoice,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.billing,
                                        "detailMakeInvoice",
                                        $$v
                                      )
                                    },
                                    expression: "billing.detailMakeInvoice"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_DetailMakeInvoice")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { disabled: _vm.isView },
                                  model: {
                                    value: _vm.billing.splitMakeInvoice,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.billing,
                                        "splitMakeInvoice",
                                        $$v
                                      )
                                    },
                                    expression: "billing.splitMakeInvoice"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_SplitMakeInvoice")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.billingNoteContainInvoice &&
                      !_vm.billing.detailMakeInvoice
                        ? _c(
                            "el-col",
                            [
                              _c("cargo-ag-grid", {
                                staticStyle: { width: "100%", height: "100px" },
                                attrs: {
                                  "grid-params":
                                    _vm.invoiceGoodsName.gridParams,
                                  "grid-options":
                                    _vm.invoiceGoodsName.gridOptions,
                                  "column-defs": _vm.invoiceGoodsNameColumnDefs,
                                  "row-data": _vm.billing.billingBeforehandVOS,
                                  "min-height": "100px"
                                },
                                on: {
                                  "update:gridParams": function($event) {
                                    return _vm.$set(
                                      _vm.invoiceGoodsName,
                                      "gridParams",
                                      $event
                                    )
                                  },
                                  "update:grid-params": function($event) {
                                    return _vm.$set(
                                      _vm.invoiceGoodsName,
                                      "gridParams",
                                      $event
                                    )
                                  },
                                  gridReady: function(params) {
                                    return (_vm.invoiceGoodsName.gridApi =
                                      params.api)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-col",
                { staticStyle: { flex: "1" }, attrs: { span: 16 } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "section",
                      staticStyle: { flex: "1", height: "100%" }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { width: "550px" },
                              attrs: { span: 10 }
                            },
                            [
                              _c(
                                "el-col",
                                [
                                  _c("el-col", { attrs: { span: 8 } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_OriginalCurrency2"
                                        )
                                      )
                                    )
                                  ]),
                                  _c("el-col", { attrs: { span: 8 } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Amount"))
                                    )
                                  ]),
                                  _c("el-col", { attrs: { span: 8 } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_ExchangeRate2")
                                      )
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100px" },
                                            attrs: { disabled: true, no: "18" },
                                            model: {
                                              value:
                                                _vm.billing.sourceCurrency1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "sourceCurrency1",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billing.sourceCurrency1"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              no: "19",
                                              "controls-position": "right",
                                              min: -999999999999,
                                              max: 999999999999,
                                              precision: 2,
                                              disabled: true
                                            },
                                            model: {
                                              value: _vm.billing.amount1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "amount1",
                                                  $$v
                                                )
                                              },
                                              expression: "billing.amount1"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("num-input", {
                                            attrs: {
                                              no: "20",
                                              min: 0,
                                              max: 999999999,
                                              precision: 8,
                                              "truncated-precision":
                                                _vm.sourceRate1Precision,
                                              disabled:
                                                _vm.billingFormParams
                                                  .sourceRate1Enable
                                            },
                                            on: { change: _vm.calculateAmount },
                                            model: {
                                              value: _vm.billing.sourceRate1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "sourceRate1",
                                                  $$v
                                                )
                                              },
                                              expression: "billing.sourceRate1"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100px" },
                                            attrs: { no: "21", disabled: true },
                                            model: {
                                              value:
                                                _vm.billing.sourceCurrency2,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "sourceCurrency2",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billing.sourceCurrency2"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              no: "22",
                                              "controls-position": "right",
                                              min: -999999999999,
                                              max: 999999999999,
                                              precision: 2,
                                              disabled: true
                                            },
                                            model: {
                                              value: _vm.billing.amount2,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "amount2",
                                                  $$v
                                                )
                                              },
                                              expression: "billing.amount2"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("num-input", {
                                            attrs: {
                                              no: "23",
                                              min: 0,
                                              max: 999999999,
                                              precision: 8,
                                              "truncated-precision":
                                                _vm.sourceRate2Precision,
                                              disabled:
                                                _vm.billingFormParams
                                                  .sourceRate2Enable
                                            },
                                            on: { change: _vm.calculateAmount },
                                            model: {
                                              value: _vm.billing.sourceRate2,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "sourceRate2",
                                                  $$v
                                                )
                                              },
                                              expression: "billing.sourceRate2"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100px" },
                                            attrs: { disabled: true, no: "24" },
                                            model: {
                                              value:
                                                _vm.billing.sourceCurrency3,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "sourceCurrency3",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billing.sourceCurrency3"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              no: "25",
                                              "controls-position": "right",
                                              min: -999999999999,
                                              max: 999999999999,
                                              precision: 2,
                                              disabled: true
                                            },
                                            model: {
                                              value: _vm.billing.amount3,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "amount3",
                                                  $$v
                                                )
                                              },
                                              expression: "billing.amount3"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("num-input", {
                                            attrs: {
                                              no: "26",
                                              min: 0,
                                              max: 999999999,
                                              precision: 8,
                                              "truncated-precision":
                                                _vm.sourceRate3Precision,
                                              disabled:
                                                _vm.billingFormParams
                                                  .sourceRate3Enable
                                            },
                                            on: { change: _vm.calculateAmount },
                                            model: {
                                              value: _vm.billing.sourceRate3,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "sourceRate3",
                                                  $$v
                                                )
                                              },
                                              expression: "billing.sourceRate3"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_BillingCurrency"
                                        )
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        attrs: {
                                          filterable: "",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Currency,
                                          no: "27",
                                          "default-value": _vm.billing.currency,
                                          disabled: _vm.isView,
                                          clearable: false
                                        },
                                        on: {
                                          parentCallBack:
                                            _vm.currencyChangeEvent
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "Billing.billingForm_taxAmount"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input-number", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          no: "28",
                                          "controls-position": "right",
                                          min: -999999999999,
                                          max: 999999999999,
                                          precision: 2,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.billing.amount,
                                          callback: function($$v) {
                                            _vm.$set(_vm.billing, "amount", $$v)
                                          },
                                          expression: "billing.amount"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "Billing.billingForm_taxFreeAmount"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input-number", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          no: "29",
                                          "controls-position": "right",
                                          min: -999999999999,
                                          max: 999999999999,
                                          precision: 2,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.billing.taxFreeAmount,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billing,
                                              "taxFreeAmount",
                                              $$v
                                            )
                                          },
                                          expression: "billing.taxFreeAmount"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-form-item",
                                { attrs: { "label-width": "0" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Remarks"))
                                    )
                                  ]),
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      no: "30",
                                      rows: 6,
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value: _vm.billing.remark,
                                      callback: function($$v) {
                                        _vm.$set(_vm.billing, "remark", $$v)
                                      },
                                      expression: "billing.remark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_AccountContacts"
                                        ),
                                        "label-width": "105px;"
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          "select-type":
                                            _vm.selectTypeNames
                                              .static_data_Contact,
                                          "allow-create": true,
                                          no: "31",
                                          filterable: "",
                                          cache: false,
                                          clearable: "",
                                          disabled: _vm.isView,
                                          "default-value":
                                            _vm.billing.accountContacts,
                                          "static-options":
                                            _vm.accountContactsArray
                                        },
                                        on: {
                                          parentCallBack:
                                            _vm.accountContactChangeEvent
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_AccountContactsTel"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          disabled: _vm.isView,
                                          no: "32"
                                        },
                                        model: {
                                          value: _vm.billing.accountContactsTel,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billing,
                                              "accountContactsTel",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "billing.accountContactsTel"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_AccountAddr"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          disabled: _vm.isView,
                                          no: "33"
                                        },
                                        model: {
                                          value: _vm.billing.accountAddr,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billing,
                                              "accountAddr",
                                              $$v
                                            )
                                          },
                                          expression: "billing.accountAddr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-form-item",
                                { attrs: { "label-width": "0" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_InvoicingRequirements"
                                        )
                                      )
                                    )
                                  ]),
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      no: "34",
                                      rows: 6,
                                      disabled: _vm.isView
                                    },
                                    model: {
                                      value: _vm.billing.invoiceDemand,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.billing,
                                          "invoiceDemand",
                                          $$v
                                        )
                                      },
                                      expression: "billing.invoiceDemand"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.billingNoteContainInvoice
                            ? _c("el-col", [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      width: "100%",
                                      "padding-top": "10px"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "50%",
                                          "padding-right": "5px"
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "Invoice.invoice_invoiceRemarks"
                                              )
                                            )
                                          )
                                        ]),
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            no: "invoiceRemark",
                                            rows: 6,
                                            disabled:
                                              _vm.isView ||
                                              !_vm.billingNoteContainInvoiceChannel
                                          },
                                          model: {
                                            value: _vm.billing.invoiceRemark,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.billing,
                                                "invoiceRemark",
                                                $$v
                                              )
                                            },
                                            expression: "billing.invoiceRemark"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { width: "50%" } },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.billingNoteContainInvoiceChannel
                                                ? _vm.$t(
                                                    "CargoMsg.Cargo_RemarkAddContent3"
                                                  )
                                                : _vm.$t(
                                                    "CargoMsg.Cargo_RemarkAddContent"
                                                  )
                                            )
                                          )
                                        ]),
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            no: "remarkAddContent",
                                            rows: 6,
                                            disabled:
                                              _vm.isView ||
                                              _vm.billingNoteContainInvoiceChannel
                                          },
                                          model: {
                                            value: _vm.billing.remarkAddContent,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.billing,
                                                "remarkAddContent",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "billing.remarkAddContent"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }